module.exports = __webpack_public_path__ + "img/video5.b01f40b0.png";